import { render, staticRenderFns } from "./modalGerenciarUsuarios.vue?vue&type=template&id=3dfa1e85&"
import script from "./modalGerenciarUsuarios.vue?vue&type=script&lang=js&"
export * from "./modalGerenciarUsuarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports